import React from 'react';
import {useField} from 'formik';

import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {FIELD_NAME_TO_DISPLAY} from 'shared/utils';

import Label from 'shared/components/label';
import FormikSlider from 'src/components/formik-slider';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import InfoTooltip from 'shared/components/info-tooltip';

interface Props {
  name: string;
  min: number;
  max: number;
  step?: number;
  optional?: boolean;
  tooltip?: string;
}

const Score = ({name, min, max, step = 1, optional = false, tooltip}: Props) => {
  const mq = useMediaQuery();
  const fieldName = `scores.${name}`;
  const [field] = useField(fieldName);
  const label = FIELD_NAME_TO_DISPLAY[name] || '';

  const input = (
    <div className="hidden-spinner">
      <FormikTextInput
        id={name}
        name={fieldName}
        className="test-score-input"
        type="number"
        min={min}
        max={max}
        step={step}
        required={!optional}
      />
    </div>
  );

  return (
    <div className="test-score">
      {mq.MS_AND_DOWN ? (
        <div className="test-score-mobile">
          {label && min && max ? (
            <Label required={!optional} className="test-score-mobile-slider-label">
              <span>
                {`${label} ${label !== 'Score' ? 'Score' : ''} (${min}-${max})`}
                {tooltip ? <InfoTooltip margin>{tooltip}</InfoTooltip> : null}
              </span>
              <div className="test-score-mobile-slider">
                <FormikSlider name={fieldName} min={min} max={max} step={step} />
                <div className="shared-font subheading bold">{field.value}</div>
              </div>
            </Label>
          ) : (
            <Label required>
              Score
              {input}
            </Label>
          )}
        </div>
      ) : (
        <>
          {input}

          {!!(label && min && max) && (
            <label className="test-score-description" htmlFor={name}>
              <p className="test-score-description-label">
                {label}
                {tooltip ? <InfoTooltip margin>{tooltip}</InfoTooltip> : null}
              </p>
              <p className="test-score-description-range">
                Score range: {min}-{max}
              </p>
            </label>
          )}
        </>
      )}
    </div>
  );
};

export default Score;
